import React from 'react';
import { Button, Grid, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { AudioOutlined } from '@ant-design/icons';
import { useTheme } from '../../../../Shared/GlobalContext/ThemeContext';
import { commonIconButtonStyle } from '../../../../Shared/Styles/iconButton';
import { getTranslatedLabel } from './FooterVoice.constants';
import PendingVoicePreview from './PendingVoicePreview';
import RecordingVoicePreview from './RecordingVoicePreview';

const { useBreakpoint } = Grid;

const FooterVoice = ({
    isRecording,
    pendingVoice,
    recordSeconds,
    waveRef,
    wavePathRef,
    liveRecordingBars,
    startRecording,
    pauseRecording,
    clearPendingVoice,
    sendPendingVoice,
    formatTime,
    setEmojiOpen,
    hasText,
    ICON_SIZE,
    buttonStyle
}) => {
    const { t } = useTranslation();
    const { isDarkMode } = useTheme();
    const screens = useBreakpoint() || {};
    const isMobile = !screens.md;

    const tt = (key, fallback) => getTranslatedLabel(t, key, fallback);
    const finalButtonStyle = buttonStyle || commonIconButtonStyle;

    if (isRecording) {
        return (
            <RecordingVoicePreview
                recordSeconds={recordSeconds}
                waveRef={waveRef}
                wavePathRef={wavePathRef}
                liveRecordingBars={liveRecordingBars}
                pauseRecording={pauseRecording}
                formatTime={formatTime}
                t={t}
                isDarkMode={isDarkMode}
                iconSize={ICON_SIZE}
                disableTooltip={isMobile}
            />
        );
    }

    if (pendingVoice) {
        return (
            <PendingVoicePreview
                pendingVoice={pendingVoice}
                clearPendingVoice={clearPendingVoice}
                sendPendingVoice={sendPendingVoice}
                setEmojiOpen={setEmojiOpen}
                t={t}
                isDarkMode={isDarkMode}
                disableTooltip={isMobile}
            />
        );
    }

    if (hasText) return null;

    const recordButton = (
        <Button
            aria-label={tt('record_voice', 'Record voice')}
            icon={<AudioOutlined style={{ fontSize: ICON_SIZE }} />}
            type="text"
            onClick={startRecording}
            style={{ ...finalButtonStyle, color: isDarkMode ? '#d9d9d9' : '#595959' }}
        />
    );

    if (isMobile) return recordButton;

    return (
        <Tooltip title={tt('record_voice', 'Record voice')}>
            {recordButton}
        </Tooltip>
    );
};

export default FooterVoice;
